<script>
import tippy from 'tippy.js';
export default {
    created(element, binding) {
        tippy(element, {
            content: binding.value,
            allowHTML: true,
            zIndex: 999
        });
    }
}
</script>
